var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 51,
    viewBox: "0 0 170 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4102 40.8307V8.61037C61.4102 7.56292 61.7716 6.67036 62.4945 5.93272C63.2321 5.20983 64.1247 4.84839 65.1721 4.84839H68.8234V18.2366H83.6941V4.84839H91.218V40.8307H83.6941V24.8312H68.8234V40.8307H61.4102Z",
    fill: "#4F48F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1303 38.3299C96.6698 37.0759 95.6224 35.3794 94.988 33.2402C94.3684 31.1158 94.0586 28.9028 94.0586 26.6014C94.0586 24.713 94.3168 22.832 94.8331 20.9584C95.3642 19.0701 96.183 17.4989 97.2894 16.2449C99.104 14.15 101.442 12.9107 104.304 12.5272C107.166 12.1436 109.748 12.3722 112.05 13.2132C114.705 14.2606 116.66 16.0752 117.914 18.657C119.094 20.9584 119.684 23.6434 119.684 26.712C119.684 28.9397 119.441 30.8576 118.954 32.4657C118.467 34.0737 117.84 35.431 117.073 36.5375C115.391 38.8389 113.259 40.2699 110.678 40.8306C108.376 41.4649 106.06 41.5166 103.729 40.9854C101.398 40.4691 99.5319 39.5839 98.1303 38.3299ZM103.154 19.9183C101.693 21.5117 101.029 23.8942 101.162 27.0661C101.31 30.2527 101.907 32.473 102.954 33.727C103.368 34.2729 104.098 34.7376 105.145 35.1212C106.193 35.5048 107.255 35.5416 108.332 35.2318C109.409 34.922 110.368 34.1401 111.209 32.8861C112.05 31.6321 112.507 29.611 112.581 26.8227C112.581 24.2999 112.175 22.4116 111.364 21.1576C110.567 19.9036 109.645 19.1069 108.597 18.7676C107.55 18.4135 106.503 18.3914 105.455 18.7012C104.408 19.0258 103.64 19.4315 103.154 19.9183Z",
    fill: "#4F48F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.819 50.6561V44.9025H124.811C126.198 44.9025 127.289 44.5779 128.086 43.9288C128.897 43.2649 129.06 42.1954 128.573 40.7201L118.836 13.0142H126.891L132.534 32.665L137.469 15.5148C137.882 13.8477 138.996 13.0142 140.81 13.0142H145.833L135.167 44.7033C134.326 47.0048 133.279 48.6424 132.025 49.616C130.771 50.457 128.713 50.8774 125.851 50.8774C125.644 50.8774 125.401 50.8774 125.121 50.8774C124.84 50.8774 124.597 50.8774 124.39 50.8774C124.169 50.8036 123.904 50.752 123.594 50.7225C123.284 50.6782 123.026 50.6561 122.819 50.6561Z",
    fill: "#4F48F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.865 39.6799C163.404 40.447 161.855 40.9191 160.217 41.0962C158.58 41.2732 157.134 41.3617 155.88 41.3617C153.357 41.3617 151.159 40.6831 149.286 39.3258C147.397 37.9538 146.453 35.704 146.453 32.5764C146.453 29.6405 147.309 27.5456 149.02 26.2916C150.731 25.0376 152.915 24.2041 155.57 23.791C155.91 23.7763 156.323 23.7173 156.81 23.614C157.296 23.5107 157.857 23.4296 158.491 23.3706C161.56 22.9428 163.094 22.0354 163.094 20.6487C163.094 19.6012 162.556 18.9152 161.479 18.5906C160.387 18.2808 159.391 18.1259 158.491 18.1259C157.518 18.1259 156.647 18.2661 155.88 18.5464C155.113 18.8267 154.552 19.3504 154.198 20.1176H147.183C147.464 17.9637 148.445 16.1859 150.127 14.7844C152 13.1763 154.685 12.3723 158.182 12.3723C162.076 12.3723 165.005 13.0362 166.967 14.364C168.988 15.7655 169.998 17.7202 169.998 20.2282V29.7438C169.998 32.5321 169.49 34.7082 168.472 36.272C167.468 37.8505 166.266 38.9865 164.865 39.6799ZM163.205 26.8228C162.216 27.3096 160.852 27.7596 159.111 28.1726L156.699 28.7037C155.445 29.0431 154.545 29.493 153.999 30.0536C153.512 30.8208 153.269 31.5879 153.269 32.3551C153.254 33.4025 153.564 34.2435 154.198 34.8778C154.833 35.4237 155.74 35.6966 156.92 35.6966C158.868 35.6966 160.402 35.1434 161.523 34.0369C162.644 32.9157 163.205 31.3814 163.205 29.434V26.8228Z",
    fill: "#4F48F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5689_42487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9277 28.967L31.0164 28.8175C29.6233 28.588 28.2232 28.9114 27.0745 29.7319L24.7736 31.3694L24.6339 30.4585C24.4244 29.0678 23.6807 27.844 22.546 27.0096L20.2695 25.3373L21.097 24.9236C22.361 24.2943 23.3002 23.213 23.7471 21.8779L24.6409 19.2043L25.2903 19.8614C26.2819 20.8627 27.6052 21.419 29.0158 21.4295L31.8439 21.4503L31.418 22.2673C30.7685 23.5155 30.6463 24.9409 31.0723 26.283L31.9277 28.967Z",
    fill: "#FFC107"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3573 15.1598L42.2419 19.2425C41.1736 21.3157 40.9726 23.685 41.6707 25.9062L44.5054 34.8333L47.3929 35.3093C48.0064 35.415 48.5247 35.7535 48.8525 36.2189C49.191 36.6843 49.3497 37.2766 49.2439 37.8901C49.0429 39.1171 47.89 39.9421 46.6631 39.7411L46.0285 39.6353L41.0572 38.8103L36.5197 38.0593C34.2139 37.6786 31.9081 38.218 30.0042 39.5719L22.3993 45.0191L22.8329 47.9278C22.9281 48.5413 22.7589 49.1231 22.4204 49.5885C22.082 50.0539 21.5637 50.3817 20.9502 50.4769C19.7233 50.6673 18.5809 49.8212 18.4011 48.5942L18.2954 47.949L17.5444 42.9777L16.8569 38.4295C16.5078 36.1237 15.2809 34.0823 13.4088 32.6967L5.87788 27.1437L3.25476 28.4553C2.69418 28.7409 2.08071 28.762 1.54128 28.5822C0.991275 28.4024 0.515301 28.011 0.240297 27.461C-0.320288 26.3504 0.134527 24.9965 1.24512 24.4465L6.32212 21.8974L10.4366 19.8454C12.5203 18.7983 14.0751 17.0002 14.8155 14.7896L17.7665 5.90473L15.7146 3.82103C15.2703 3.37679 15.0588 2.80562 15.0588 2.22387C15.0694 1.65271 15.2915 1.08154 15.7357 0.647875C16.6136 -0.219453 18.0309 -0.219452 18.9088 0.669031L19.3637 1.13443L22.8964 4.72009L26.1224 7.98843C27.7619 9.64905 29.9513 10.5798 32.2888 10.5904L41.6496 10.6539L42.9928 8.0519C43.2784 7.50188 43.765 7.12111 44.3044 6.95187C44.8544 6.77206 45.4679 6.81437 46.0179 7.09995C47.1179 7.66054 47.5516 9.01442 46.9804 10.1144L46.6842 10.6962L44.3573 15.1598ZM39.5236 34.0083L37.387 27.26C36.3187 23.8965 36.6254 20.3108 38.2543 17.18L39.3226 15.1174L32.2465 15.0751C28.7138 15.0434 25.4032 13.6472 22.9176 11.1299L21.2993 9.49039L19.0569 16.1963C17.9463 19.5493 15.5982 22.2676 12.4357 23.8436L10.3626 24.8802L16.0636 29.0793C18.8983 31.1842 20.7598 34.2621 21.2887 37.7526L21.6377 40.0373L27.3811 35.9227C30.258 33.8602 33.7591 33.0458 37.2389 33.6275L39.5236 34.0083Z",
    fill: "url(#paint0_linear_5689_42487)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter1_f_5689_42487)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3742 24.8904L12.4473 26.4241L7.95201 28.677L5.87891 27.1433L10.3742 24.8904Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter2_f_5689_42487)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.731 38.5454L24.4925 43.5273L22.3983 45.0186L21.6367 40.0474L23.731 38.5454Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter3_f_5689_42487)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5366 34.0079L38.7539 31.554L43.7251 32.379L44.5078 34.8329L39.5366 34.0079Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter4_f_5689_42487)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3241 15.1278L36.7539 15.1066L39.0703 10.6431L41.6511 10.6536L39.3241 15.1278Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter5_f_5689_42487)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7676 5.90454L21.3109 9.4902L20.4964 11.9335L16.9531 8.34787L17.7676 5.90454Z",
    fill: "black"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6634 32.003L34.8955 31.7118C32.202 31.2646 29.4981 31.8886 27.2726 33.4798L22.832 36.6621L22.5616 34.8941C22.156 32.2006 20.7209 29.8191 18.5162 28.1967L14.1172 24.952L15.7187 24.1513C18.1626 22.9241 19.9825 20.8234 20.8457 18.2339L22.572 13.0444L23.82 14.3132C25.7439 16.2579 28.3022 17.3395 31.0373 17.3603L36.5074 17.4019L35.6755 18.993C34.4275 21.4162 34.1883 24.1825 35.0099 26.7824L36.6634 32.003Z",
    fill: "url(#paint1_linear_5689_42487)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_5689_42487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2996 27.7813L29.6271 27.6709C28.5989 27.5016 27.5655 27.7402 26.7177 28.3458L25.0195 29.5544L24.9165 28.8821C24.7618 27.8557 24.213 26.9524 23.3755 26.3366L21.6953 25.1024L22.306 24.797C23.2389 24.3326 23.9321 23.5345 24.2619 22.5492L24.9216 20.5759L25.4009 21.0609C26.1328 21.7999 27.1094 22.2105 28.1505 22.2182L30.2378 22.2336L29.9234 22.8366C29.4441 23.7578 29.3539 24.8098 29.6683 25.8003L30.2996 27.7813Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5689_42487",
    x: 19.2695,
    y: 19.2043,
    width: 13.6562,
    height: 15.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5689_42487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5689_42487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5689_42487",
    x: 4.87891,
    y: 23.8904,
    width: 8.57031,
    height: 5.78662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_5689_42487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5689_42487",
    x: 20.6367,
    y: 37.5454,
    width: 4.85547,
    height: 8.47314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_5689_42487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_5689_42487",
    x: 37.7539,
    y: 30.554,
    width: 7.75391,
    height: 5.27881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_5689_42487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5689_42487",
    x: 35.7539,
    y: 9.64307,
    width: 6.89844,
    height: 6.48462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_5689_42487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_5689_42487",
    x: 15.9531,
    y: 4.90454,
    width: 6.35938,
    height: 8.02905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_5689_42487"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_5689_42487",
    x: 20.6953,
    y: 20.5759,
    width: 10.6055,
    height: 11.9785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5689_42487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5689_42487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5689_42487",
    x1: -3.13586e-7,
    y1: -3.80081,
    x2: 64.2683,
    y2: 38.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2224,
    stopColor: "#4F48F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5689_42487",
    x1: 14.1172,
    y1: 13.0444,
    x2: 36.6634,
    y2: 13.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F06141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.e2d221c334ecd087092b713351aa3ffc.svg";
export { ForwardRef as ReactComponent };